import { render, staticRenderFns } from "./batteryLevel.vue?vue&type=template&id=ba4d9a58&scoped=true&"
import script from "./batteryLevel.vue?vue&type=script&lang=js&"
export * from "./batteryLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d9a58",
  null
  
)

export default component.exports